window.addEventListener("load", function () {
  $(".floatright__close").on("click", function () {
    $("#gno-ld-26-tet-floatright").toggleClass("active");
    $(this).toggleClass("active");
  });
});
